import { shallowMount } from "@vue/test-utils";
import Vue from "vue";
import formValidator from "@/mixins/form-validator";

Vue.mixin(formValidator);

describe("FormValidator Mixin", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Vue, {
      propsData: {
        required: true
      }
    });
  });

  it("sets validCheck to false by default", () => {
    expect(wrapper.vm.validCheck).toBe(false);
  });

  it("sets required prop correctly", () => {
    expect(wrapper.vm.required).toBe(true);
  });

  it("checkValid sets validCheck to true", () => {
    wrapper.vm.checkValid();
    expect(wrapper.vm.validCheck).toBe(true);
  });

  it("isValid returns true when required is false", () => {
    wrapper.vm.required = false;
    expect(wrapper.vm.isValid()).toBe(true);
  });

  it("isValid returns false when required is true and value is empty", () => {
    wrapper.vm.$data.value = "";
    expect(wrapper.vm.isValid()).toBe(false);
  });

  it("error returns null when validCheck is false", () => {
    wrapper.vm.validCheck = false;
    expect(wrapper.vm.error).toBe(null);
  });

  it("error returns error message when validCheck is true and isValid es false", () => {
    wrapper.vm.validCheck = true;
    expect(wrapper.vm.error).toBe("Tenés que ingresar este dato");
  });
});
